import { render } from "./read-only-proposal-details.vue?vue&type=template&id=70499825&lang=true"
import script from "./read-only-proposal-details.vue?vue&type=script&lang=js"
export * from "./read-only-proposal-details.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__